import axios from "axios";

export const putTripInclude = async (tripID: number, catchReportID: number) => {
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_API}/Trip/include?TripID=${tripID}&CatchReportID=${catchReportID}`
    );
    return response;
  } catch (error: any) {
    console.error(error);
    return error.response;
  }
};
